import mixin from './mixin';

const axios = require('axios');

import Activity from './components/Activity.vue'; 

const activitiesWidgetApp = {
	mixins: [mixin],
	components: { Activity },
    data() {
        return {
			dataApi: '/api/activities',
			dataLimit: 4,
			dataFill: false,
			dataGuid: '',
			dataLanguage: 'nl-NL',
			dataOverrules: [],
			dataFirm: '',

			loading: false,
			data: null,
        };
    },
    computed: {
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
		},
		queryParams() {
			const urlParams = new URLSearchParams();
			urlParams.set('parentNodeId', this.dataGuid);
			urlParams.set('cultureCode', this.dataLanguage);
			return urlParams.toString();
		},
		filteredItems() {
			if (!this.itemsSet) return [];

			let filteredItems = this.data.items
				.filter(item => this.dataOverrules.includes(item.id))
				.sort((a, b) => this.dataOverrules.indexOf(a.id) - this.dataOverrules.indexOf(b.id));

			filteredItems = this.removeDuplicatesById(filteredItems);
			if (filteredItems.length >= this.dataLimit) return filteredItems.slice(0, this.dataLimit);

			if (this.dataFirm) {
				const itemsByFirm = this.data.items
					.filter(item => item.firma === this.dataFirm)
					.sort((a, b) => new Date(a.datum) - new Date(b.datum));

				filteredItems = this.removeDuplicatesById([...filteredItems, ...itemsByFirm]);

				if (filteredItems.length >= this.dataLimit) return filteredItems.slice(0, this.dataLimit);
			}

			if (this.dataFill) {
				const itemsSortedByDate = [...this.data.items].sort((a, b) => new Date(a.datum) - new Date(b.datum));
				filteredItems = this.removeDuplicatesById([...filteredItems, ...itemsSortedByDate]);
			}

			return filteredItems.slice(0, this.dataLimit);
		}
    },
    methods: {
		async init() {
			this.loading = true;

			if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
			if (this.$el.dataset.guid) this.dataGuid = this.$el.dataset.guid;
			if (this.$el.dataset.language) this.dataLanguage = this.$el.dataset.language;
			if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
			if (this.$el.dataset.fill) this.dataFill = this.$el.dataset.fill === 'True';
			if (this.$el.dataset.overrules) this.dataOverrules = this.$el.dataset.overrules.split(',');
			if (this.$el.dataset.firm) this.dataFirm = this.$el.dataset.firm;

			const response = await this.fetchData();
			if (response && response.data) this.data = response.data;
			this.loading = false;
		},
		async fetchData() {
			try {
				const response = await axios.get(`${this.dataApi}?${this.queryParams}`);
				return response;
			} catch (error) {
				console.log(error);
			}
		},
		removeDuplicatesById(array) {
			return array.reduce((accumulator, current) => {
				if (!accumulator.find((item) => item.id === current.id)) {
					accumulator.push(current);
				}
				return accumulator;
			}, []);
		},
    },
    mounted() {
		this.init();
    },
};

export default activitiesWidgetApp;